"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConditionalLinkWrapper = void 0;
var react_1 = __importDefault(require("react"));
var css_1 = require("@emotion/css");
var design_system_typography_1 = require("@contrast-security-inc/design-system-typography");
var shared_1 = require("../shared");
var conditionalLinkStyles = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  cursor: pointer;\n"], ["\n  align-items: center;\n  cursor: pointer;\n"])));
var ConditionalLinkWrapper = function (_a) {
    var LinkProps = _a.LinkProps, children = _a.children;
    return LinkProps ? (react_1.default.createElement(design_system_typography_1.Link, __assign({}, LinkProps, { hideExternalIcon: true, className: (0, css_1.cx)(LinkProps.className, shared_1.rowFlexStyle, conditionalLinkStyles) }), children)) : (children);
};
exports.ConditionalLinkWrapper = ConditionalLinkWrapper;
var templateObject_1;
